export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.zy-crm.lead.title': '線索列表',
  'pages.zy-crm.customer.title': '客戶列表',
  'pages.zy-crm.contact.title': '聯絡人列表',
  'pages.zy-crm.contact.detailTitle': '聯絡人詳情',
  'pages.zy-crm.common.confirmDelete': '確認刪除',
  'pages.zy-crm.common.confirmDeleteContent': '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.common.deleteSuccess': '刪除成功',
  'pages.zy-crm.common.updateSuccess': '更新成功',
  'pages.zy-crm.common.createSuccess': '創建成功',
  'pages.zy-crm.common.operation': '操作',
  'pages.zy-crm.common.detail': '詳情',
  'pages.zy-crm.common.edit': '編輯',
  'pages.zy-crm.common.delete': '刪除',
  'pages.zy-crm.common.refresh': '刷新',
  'pages.zy-crm.common.create': '新建',
  'pages.zy-crm.common.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.common.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.common.noDetailData': '未找到詳情資料',
  'pages.zy-crm.common.id': 'ID',
  'pages.zy-crm.common.relatedData': '關聯資料',
  'pages.zy-crm.common.relatedDataTodo': '關聯資料可按業務介面補充',
  'pages.zy-crm.common.required': '必填項',
  'pages.zy-crm.common.yes': '是',
  'pages.zy-crm.common.no': '否',
  'pages.zy-crm.opportunityPipelines.title': '商機管道配置',
  'pages.zy-crm.opportunityStages.title': '商機階段配置',
  'pages.zy-crm.areas.title': '地區配置',
  'pages.zy-crm.industries.title': '行業配置',
  'pages.zy-crm.productCategories.title': '產品分類配置',
  'pages.zy-crm.sourceChannels.title': '來源渠道配置',
  'pages.zy-crm.dictionary.column.id': 'ID',
  'pages.zy-crm.dictionary.column.uuid': '標識',
  'pages.zy-crm.dictionary.column.name': '名稱',
  'pages.zy-crm.dictionary.column.updateTime': '更新時間',
  'pages.zy-crm.dictionary.confirmDeleteOne': '確認刪除此筆記錄嗎？',
  'pages.zy-crm.dictionary.modal.editTitle': '編輯{title}',
  'pages.zy-crm.dictionary.modal.createTitle': '新建{title}',
  'pages.zy-crm.dictionary.validation.nameRequired': '名稱不能為空',
  'pages.zy-crm.dictionary.validation.enterName': '請輸入名稱',
  'pages.zy-crm.dictionary.field.name': '名稱',
  'pages.zy-crm.dictionary.field.uuidOptional': '標識（系統生成）',
  'pages.zy-crm.dictionary.field.uuidHint': '由系統自動生成，無需手動填寫',
  'pages.zy-crm.dictionaryManagement.field.type': '字典類型',
  'pages.zy-crm.contact.management': '聯絡人管理',
  'pages.zy-crm.contact.unknownMember': '未知成員',
  'pages.zy-crm.contact.memberLoadFailed': '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.contact.memberLoadFailedSubmit':
    '成員列表載入失敗，無法提交，請先重試',
  'pages.zy-crm.contact.field.name': '聯絡人姓名',
  'pages.zy-crm.contact.field.customer': '客戶',
  'pages.zy-crm.contact.field.lastContactTime': '最近聯繫時間',
  'pages.zy-crm.contact.field.lastContactContent': '最近聯繫內容',
  'pages.zy-crm.contact.field.nextContactTime': '下次聯繫時間',
  'pages.zy-crm.contact.field.owner': '負責人',
  'pages.zy-crm.contact.field.mobile': '手機號',
  'pages.zy-crm.contact.field.telephone': '電話',
  'pages.zy-crm.contact.field.email': '郵箱',
  'pages.zy-crm.contact.field.qq': 'QQ',
  'pages.zy-crm.contact.field.wechat': '微信',
  'pages.zy-crm.contact.field.area': '地區',
  'pages.zy-crm.contact.field.parent': '上級聯絡人',
  'pages.zy-crm.contact.field.detailAddress': '詳細地址',
  'pages.zy-crm.contact.field.remark': '備註',
  'pages.zy-crm.contact.field.post': '職位',
  'pages.zy-crm.contact.field.sex': '性別',
  'pages.zy-crm.contact.field.isPrimaryDecisionMaker': '主要決策人',
  'pages.zy-crm.contact.placeholder.name': '請輸入聯絡人姓名',
  'pages.zy-crm.contact.placeholder.lastContactContent': '請輸入最近聯繫內容',
  'pages.zy-crm.contact.placeholder.lastContactTime': '請選擇最近聯繫時間',
  'pages.zy-crm.contact.placeholder.nextContactTime': '請選擇下次聯繫時間',
  'pages.zy-crm.contact.placeholder.email': '請輸入郵箱',
  'pages.zy-crm.contact.placeholder.mobile': '請輸入手機號',
  'pages.zy-crm.contact.placeholder.qq': '請輸入QQ',
  'pages.zy-crm.contact.placeholder.telephone': '請輸入電話',
  'pages.zy-crm.contact.placeholder.wechat': '請輸入微信',
  'pages.zy-crm.contact.placeholder.area': '請輸入地區編號',
  'pages.zy-crm.contact.placeholder.customer': '請輸入客戶編號',
  'pages.zy-crm.contact.placeholder.owner': '請選擇負責人',
  'pages.zy-crm.contact.placeholder.parent': '請輸入上級聯絡人編號',
  'pages.zy-crm.contact.placeholder.detailAddress': '請輸入詳細地址',
  'pages.zy-crm.contact.placeholder.remark': '請輸入備註',
  'pages.zy-crm.contact.placeholder.isPrimaryDecisionMaker':
    '請選擇是否為主要決策人',
  'pages.zy-crm.contact.placeholder.post': '請輸入職位',
  'pages.zy-crm.contact.placeholder.sex': '請輸入性別編碼',
  'pages.zy-crm.contact.section.basic': '基礎資訊',
  'pages.zy-crm.contact.section.followUp': '跟進資訊',
  'pages.zy-crm.contact.section.contact': '聯絡方式',
  'pages.zy-crm.contact.section.relation': '關聯資訊',
  'pages.zy-crm.contact.section.remark': '備註或補充',
  'pages.zy-crm.contact.section.other': '其他資訊',
  'pages.zy-crm.opportunity.title': 'Opportunity列表',
  'pages.zy-crm.opportunity.detailTitle': 'Opportunity詳情',
  'pages.zy-crm.opportunity.card.manageTitle': 'Opportunity管理',
  'pages.zy-crm.opportunity.action.refresh': '刷新',
  'pages.zy-crm.opportunity.action.create': '新增',
  'pages.zy-crm.opportunity.action.detail': '詳情',
  'pages.zy-crm.opportunity.action.edit': '編輯',
  'pages.zy-crm.opportunity.action.delete': '刪除',
  'pages.zy-crm.opportunity.column.operation': '操作',
  'pages.zy-crm.opportunity.modal.createTitle': '新增',
  'pages.zy-crm.opportunity.modal.editTitle': '編輯',
  'pages.zy-crm.opportunity.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.opportunity.modal.deleteContent':
    '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.opportunity.form.required': '必填項',
  'pages.zy-crm.opportunity.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.opportunity.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.opportunity.form.placeholder.relation': '請輸入關聯{label}',
  'pages.zy-crm.opportunity.form.bool.yes': '是',
  'pages.zy-crm.opportunity.form.bool.no': '否',
  'pages.zy-crm.opportunity.form.group.basic': '基礎資訊',
  'pages.zy-crm.opportunity.form.group.followup': '跟進資訊',
  'pages.zy-crm.opportunity.form.group.contact': '聯絡方式',
  'pages.zy-crm.opportunity.form.group.business': '業務資訊',
  'pages.zy-crm.opportunity.form.group.relation': '關聯資訊',
  'pages.zy-crm.opportunity.form.group.detail': '備註或補充',
  'pages.zy-crm.opportunity.form.group.other': '其他資訊',
  'pages.zy-crm.opportunity.message.createSuccess': '建立成功',
  'pages.zy-crm.opportunity.message.updateSuccess': '更新成功',
  'pages.zy-crm.opportunity.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.opportunity.message.noCreateApi': '後端未提供新增接口',
  'pages.zy-crm.opportunity.message.noUpdateApi': '後端未提供更新接口',
  'pages.zy-crm.opportunity.message.noDeleteApi': '後端未提供刪除接口',
  'pages.zy-crm.opportunity.message.memberLoadFailed':
    '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.opportunity.message.memberLoadBlocked':
    '成員列表載入失敗，暫時無法提交',
  'pages.zy-crm.opportunity.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.opportunity.member.unknown': '未知成員',
  'pages.zy-crm.opportunity.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.opportunity.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.opportunity.state.relationDataEmpty':
    '關聯資料可按業務接口補充',
  'pages.zy-crm.opportunity.card.relation': '關聯資料',
  'pages.zy-crm.opportunity.field.id': '編號',
  'pages.zy-crm.opportunity.field.name': '商機名稱',
  'pages.zy-crm.opportunity.field.customer': '客戶',
  'pages.zy-crm.opportunity.field.followUpStatus': '跟進狀態',
  'pages.zy-crm.opportunity.field.contactLastTime': '最近聯絡時間',
  'pages.zy-crm.opportunity.field.contactNextTime': '下次聯絡時間',
  'pages.zy-crm.opportunity.field.ownerUser': '負責人',
  'pages.zy-crm.opportunity.field.pipeline': '商機管道',
  'pages.zy-crm.opportunity.field.stage': '商機階段',
  'pages.zy-crm.opportunity.field.endStatus': '結束狀態',
  'pages.zy-crm.opportunity.field.dealTime': '成交時間',
  'pages.zy-crm.opportunity.field.totalProductPrice': '產品總價',
  'pages.zy-crm.opportunity.field.discountPercent': '折扣比例',
  'pages.zy-crm.opportunity.field.totalPrice': '合計金額',
  'pages.zy-crm.opportunity.field.remark': '備註',
  'pages.zy-crm.opportunity.field.endRemark': '結束備註',
  'pages.zy-crm.product.title': '產品列表',
  'pages.zy-crm.product.detailTitle': '產品詳情',
  'pages.zy-crm.product.card.manageTitle': '產品管理',
  'pages.zy-crm.product.field.name': '產品名稱',
  'pages.zy-crm.product.field.code': '產品編碼',
  'pages.zy-crm.product.field.unit': '產品單位',
  'pages.zy-crm.product.field.price': '價格',
  'pages.zy-crm.product.field.costPrice': '成本價',
  'pages.zy-crm.product.field.status': '是否上下架',
  'pages.zy-crm.product.field.category': '產品類型',
  'pages.zy-crm.product.field.description': '產品描述',
  'pages.zy-crm.product.field.mainImage': '產品主圖',
  'pages.zy-crm.product.field.detailImages': '產品詳情圖',
  'pages.zy-crm.product.field.owner': '負責人',
  'pages.zy-crm.product.action.refresh': '刷新',
  'pages.zy-crm.product.action.create': '新增',
  'pages.zy-crm.product.action.detail': '詳情',
  'pages.zy-crm.product.action.edit': '編輯',
  'pages.zy-crm.product.action.delete': '刪除',
  'pages.zy-crm.product.column.operation': '操作',
  'pages.zy-crm.product.modal.createTitle': '新增產品',
  'pages.zy-crm.product.modal.editTitle': '編輯產品',
  'pages.zy-crm.product.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.product.modal.deleteContent': '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.product.form.required': '必填項',
  'pages.zy-crm.product.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.product.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.product.form.placeholder.relation': '請輸入關聯{label}',
  'pages.zy-crm.product.form.bool.yes': '是',
  'pages.zy-crm.product.form.bool.no': '否',
  'pages.zy-crm.product.form.group.basic': '基礎資訊',
  'pages.zy-crm.product.form.group.followup': '跟進資訊',
  'pages.zy-crm.product.form.group.contact': '聯絡方式',
  'pages.zy-crm.product.form.group.business': '業務資訊',
  'pages.zy-crm.product.form.group.relation': '關聯資訊',
  'pages.zy-crm.product.form.group.detail': '備註或補充',
  'pages.zy-crm.product.form.group.other': '其他資訊',
  'pages.zy-crm.product.form.autoCodeHint': '根據編號規則自動產生',
  'pages.zy-crm.product.enum.status.enabled': '啟用/在售',
  'pages.zy-crm.product.enum.status.disabled': '停用/下架',
  'pages.zy-crm.product.message.createSuccess': '建立成功',
  'pages.zy-crm.product.message.updateSuccess': '更新成功',
  'pages.zy-crm.product.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.product.message.noCreateApi': '後端未提供新增接口',
  'pages.zy-crm.product.message.noUpdateApi': '後端未提供更新接口',
  'pages.zy-crm.product.message.noDeleteApi': '後端未提供刪除接口',
  'pages.zy-crm.product.message.memberLoadFailed':
    '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.product.message.memberLoadBlocked':
    '成員列表載入失敗，暫時無法提交',
  'pages.zy-crm.product.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.product.member.unknown': '未知成員',
  'pages.zy-crm.product.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.product.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.product.state.relationDataEmpty': '關聯資料可按業務接口補充',
  'pages.zy-crm.product.card.relation': '關聯資料',
  'pages.zy-crm.contract.title': 'Contract列表',
  'pages.zy-crm.contract.detailTitle': 'Contract詳情',
  'pages.zy-crm.contract.card.manageTitle': 'Contract管理',
  'pages.zy-crm.contract.action.refresh': '刷新',
  'pages.zy-crm.contract.action.create': '新增',
  'pages.zy-crm.contract.action.detail': '詳情',
  'pages.zy-crm.contract.action.edit': '編輯',
  'pages.zy-crm.contract.action.delete': '刪除',
  'pages.zy-crm.contract.column.operation': '操作',
  'pages.zy-crm.contract.modal.createTitle': '新增',
  'pages.zy-crm.contract.modal.editTitle': '編輯',
  'pages.zy-crm.contract.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.contract.modal.deleteContent': '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.contract.form.required': '必填項',
  'pages.zy-crm.contract.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.contract.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.contract.form.placeholder.relation': '請輸入關聯{label}',
  'pages.zy-crm.contract.form.bool.yes': '是',
  'pages.zy-crm.contract.form.bool.no': '否',
  'pages.zy-crm.contract.form.group.basic': '基礎資訊',
  'pages.zy-crm.contract.form.group.followup': '跟進資訊',
  'pages.zy-crm.contract.form.group.contact': '聯絡方式',
  'pages.zy-crm.contract.form.group.business': '業務資訊',
  'pages.zy-crm.contract.form.group.relation': '關聯資訊',
  'pages.zy-crm.contract.form.group.sign': '簽約資訊',
  'pages.zy-crm.contract.form.group.product': '產品資訊',
  'pages.zy-crm.contract.form.group.amount': '金額彙總',
  'pages.zy-crm.contract.form.group.detail': '備註或補充',
  'pages.zy-crm.contract.form.group.other': '其他資訊',
  'pages.zy-crm.contract.form.autoCodeHint': '根據編號規則自動生成',
  'pages.zy-crm.contract.message.createSuccess': '建立成功',
  'pages.zy-crm.contract.message.updateSuccess': '更新成功',
  'pages.zy-crm.contract.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.contract.message.noCreateApi': '後端未提供新增接口',
  'pages.zy-crm.contract.message.noUpdateApi': '後端未提供更新接口',
  'pages.zy-crm.contract.message.noDeleteApi': '後端未提供刪除接口',
  'pages.zy-crm.contract.message.memberLoadFailed':
    '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.contract.message.customerLoadFailed':
    '客戶列表載入失敗，請稍後重試',
  'pages.zy-crm.contract.message.opportunityLoadFailed':
    '商機列表載入失敗，請稍後重試',
  'pages.zy-crm.contract.message.memberLoadBlocked':
    '成員列表載入失敗，暫時無法提交',
  'pages.zy-crm.contract.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.contract.message.loadDetailFailed': '載入合約詳情失敗',
  'pages.zy-crm.contract.message.productEmpty': '請至少新增一筆產品明細',
  'pages.zy-crm.contract.member.unknown': '未知成員',
  'pages.zy-crm.contract.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.contract.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.contract.state.relationDataEmpty': '關聯資料可按業務接口補充',
  'pages.zy-crm.contract.card.relation': '關聯資料',
  'pages.zy-crm.contract.card.productDetail': '產品明細',
  'pages.zy-crm.contract.search.expand': '展開',
  'pages.zy-crm.contract.search.collapse': '收起',
  'pages.zy-crm.contract.enum.type.standard': '標準合約',
  'pages.zy-crm.contract.enum.type.framework': '框架合約',
  'pages.zy-crm.contract.enum.type.supplement': '補充協議',
  'pages.zy-crm.contract.action.addProduct': '添加產品',
  'pages.zy-crm.contract.action.addRow': '添加行',
  'pages.zy-crm.contract.table.emptyProducts': '暫無產品明細',
  'pages.zy-crm.contract.field.id': 'ID',
  'pages.zy-crm.contract.field.name': '名稱',
  'pages.zy-crm.contract.field.code': '合約編號',
  'pages.zy-crm.contract.field.customer': '客戶',
  'pages.zy-crm.contract.field.opportunity': '商機',
  'pages.zy-crm.contract.field.contactLastTime': '最近聯絡時間',
  'pages.zy-crm.contract.field.ownerUser': '負責人',
  'pages.zy-crm.contract.field.processInstance': '流程實例',
  'pages.zy-crm.contract.field.auditStatus': '審批狀態',
  'pages.zy-crm.contract.field.orderDate': '下單日期',
  'pages.zy-crm.contract.field.startTime': '開始時間',
  'pages.zy-crm.contract.field.endTime': '結束時間',
  'pages.zy-crm.contract.field.contractType': '合約類型',
  'pages.zy-crm.contract.field.customerSigner': '客戶簽約人',
  'pages.zy-crm.contract.field.companySignerUserUuid': '公司簽約人',
  'pages.zy-crm.contract.field.signContactUuid': '簽約聯絡人',
  'pages.zy-crm.contract.field.signUserUuid': '簽約人',
  'pages.zy-crm.contract.field.contractImageUrl': '合約影像',
  'pages.zy-crm.contract.field.totalProductPrice': '產品總價',
  'pages.zy-crm.contract.field.discountPercent': '折扣比例',
  'pages.zy-crm.contract.field.totalPrice': '合約總價',
  'pages.zy-crm.contract.field.profitAmount': '利潤',
  'pages.zy-crm.contract.field.productName': '產品名稱',
  'pages.zy-crm.contract.field.productType': '產品類型',
  'pages.zy-crm.contract.field.productUnit': '產品單位',
  'pages.zy-crm.contract.field.listPrice': '價格',
  'pages.zy-crm.contract.field.costPrice': '成本價',
  'pages.zy-crm.contract.field.salePrice': '售價',
  'pages.zy-crm.contract.field.quantity': '數量',
  'pages.zy-crm.contract.field.lineTotal': '小計',
  'pages.zy-crm.contract.field.signContact': '簽約聯絡人',
  'pages.zy-crm.contract.field.signUser': '簽約人',
  'pages.zy-crm.contract.field.remark': '備註',
  'pages.zy-crm.contract.field.customerUuid': '客戶名稱',
  'pages.zy-crm.contract.field.opportunityUuid': '商機名稱',
  'pages.zy-crm.contract.field.ownerUserUuid': '負責人',
  'pages.zy-crm.contract.field.processInstanceUuid': '流程實例',
  'pages.zy-crm.contractCodeRule.title': '合約編號規則',
  'pages.zy-crm.contractCodeRule.cardTitle': '合約編號規則',
  'pages.zy-crm.contractCodeRule.action.save': '儲存',
  'pages.zy-crm.contractCodeRule.action.reset': '重置',
  'pages.zy-crm.contractCodeRule.message.saveSuccess': '合約編號規則儲存成功',
  'pages.zy-crm.contractCodeRule.message.loadFailed': '載入合約編號規則失敗',
  'pages.zy-crm.contractCodeRule.message.saveFailed': '儲存合約編號規則失敗',
  'pages.zy-crm.contractCodeRule.form.required': '必填項',
  'pages.zy-crm.contractCodeRule.field.prefix': '編號前綴',
  'pages.zy-crm.contractCodeRule.field.dateFormat': '日期格式',
  'pages.zy-crm.contractCodeRule.field.seqLength': '流水號位數',
  'pages.zy-crm.contractCodeRule.field.resetCycle': '重置週期',
  'pages.zy-crm.contractCodeRule.preview.label': '下一編號預覽',
  'pages.zy-crm.contractCodeRule.enum.date.none': '不使用日期',
  'pages.zy-crm.contractCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.contractCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.contractCodeRule.enum.cycle.none': '不重置',
  'pages.zy-crm.contractCodeRule.enum.cycle.year': '按年重置',
  'pages.zy-crm.contractCodeRule.enum.cycle.month': '按月重置',
  'pages.zy-crm.productCodeRule.title': '產品編號規則',
  'pages.zy-crm.productCodeRule.cardTitle': '產品編號規則',
  'pages.zy-crm.productCodeRule.action.save': '儲存',
  'pages.zy-crm.productCodeRule.action.reset': '重置',
  'pages.zy-crm.productCodeRule.message.saveSuccess': '產品編號規則儲存成功',
  'pages.zy-crm.productCodeRule.message.loadFailed': '載入產品編號規則失敗',
  'pages.zy-crm.productCodeRule.message.saveFailed': '儲存產品編號規則失敗',
  'pages.zy-crm.productCodeRule.form.required': '必填項',
  'pages.zy-crm.productCodeRule.field.prefix': '編號前綴',
  'pages.zy-crm.productCodeRule.field.dateFormat': '日期格式',
  'pages.zy-crm.productCodeRule.field.seqLength': '流水號位數',
  'pages.zy-crm.productCodeRule.field.resetCycle': '重置週期',
  'pages.zy-crm.productCodeRule.preview.label': '下一編號預覽',
  'pages.zy-crm.productCodeRule.enum.date.none': '不使用日期',
  'pages.zy-crm.productCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.productCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.productCodeRule.enum.cycle.none': '不重置',
  'pages.zy-crm.productCodeRule.enum.cycle.year': '按年重置',
  'pages.zy-crm.productCodeRule.enum.cycle.month': '按月重置',
  'pages.zy-crm.receipt.title': 'Receipt列表',
  'pages.zy-crm.receipt.card.manageTitle': 'Receipt管理',
  'pages.zy-crm.receipt.action.refresh': '刷新',
  'pages.zy-crm.receipt.action.create': '新增',
  'pages.zy-crm.receipt.action.detail': '詳情',
  'pages.zy-crm.receipt.action.edit': '編輯',
  'pages.zy-crm.receipt.action.delete': '刪除',
  'pages.zy-crm.receipt.column.operation': '操作',
  'pages.zy-crm.receipt.modal.createTitle': '新增',
  'pages.zy-crm.receipt.modal.editTitle': '編輯',
  'pages.zy-crm.receipt.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.receipt.modal.deleteContent': '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.receipt.form.required': '必填項',
  'pages.zy-crm.receipt.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.receipt.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.receipt.form.placeholder.relation': '請輸入關聯{label}',
  'pages.zy-crm.receipt.form.bool.yes': '是',
  'pages.zy-crm.receipt.form.bool.no': '否',
  'pages.zy-crm.receipt.form.group.basic': '基礎資訊',
  'pages.zy-crm.receipt.form.group.followup': '跟進資訊',
  'pages.zy-crm.receipt.form.group.contact': '聯絡方式',
  'pages.zy-crm.receipt.form.group.business': '業務資訊',
  'pages.zy-crm.receipt.form.group.relation': '關聯資訊',
  'pages.zy-crm.receipt.form.group.detail': '備註或補充',
  'pages.zy-crm.receipt.form.group.other': '其他資訊',
  'pages.zy-crm.receipt.message.createSuccess': '建立成功',
  'pages.zy-crm.receipt.message.updateSuccess': '更新成功',
  'pages.zy-crm.receipt.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.receipt.message.noCreateApi': '後端未提供新增接口',
  'pages.zy-crm.receipt.message.noUpdateApi': '後端未提供更新接口',
  'pages.zy-crm.receipt.message.noDeleteApi': '後端未提供刪除接口',
  'pages.zy-crm.receipt.message.memberLoadFailed':
    '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.receipt.message.memberLoadBlocked':
    '成員列表載入失敗，暫時無法提交',
  'pages.zy-crm.receipt.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.receipt.member.unknown': '未知成員',
  'pages.zy-crm.receipt.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.receipt.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.receipt.state.relationDataEmpty': '關聯資料可按業務接口補充',
  'pages.zy-crm.receipt.card.relation': '關聯資料',
  'pages.zy-crm.receipt.search.expand': '展開',
  'pages.zy-crm.receipt.search.collapse': '收起',
  'pages.zy-crm.receipt.field.id': 'id',
  'pages.zy-crm.receipt.field.code': 'code',
  'pages.zy-crm.receipt.field.receiptScheduleUuid': 'receiptSchedule',
  'pages.zy-crm.receipt.field.customerUuid': 'customer',
  'pages.zy-crm.receipt.field.contractUuid': 'contract',
  'pages.zy-crm.receipt.field.ownerUserUuid': '负责人',
  'pages.zy-crm.receipt.field.auditStatus': 'auditStatus',
  'pages.zy-crm.receipt.field.processInstanceUuid': 'processInstance',
  'pages.zy-crm.receipt.field.receiptDate': 'receiptDate',
  'pages.zy-crm.receipt.field.receiptMethod': 'receiptMethod',
  'pages.zy-crm.receipt.field.price': 'price',
  'pages.zy-crm.receipt.field.remark': 'remark',
  'pages.zy-crm.receipt.placeholder.autoCode': '根據系統規則自動生成',
  'pages.zy-crm.receipt-schedule.title': 'ReceiptSchedule列表',
  'pages.zy-crm.receipt-schedule.detailTitle': 'ReceiptSchedule詳情',
  'pages.zy-crm.receipt-schedule.card.manageTitle': 'ReceiptSchedule管理',
  'pages.zy-crm.receipt-schedule.action.refresh': '刷新',
  'pages.zy-crm.receipt-schedule.action.create': '新增',
  'pages.zy-crm.receipt-schedule.action.detail': '詳情',
  'pages.zy-crm.receipt-schedule.action.edit': '編輯',
  'pages.zy-crm.receipt-schedule.action.delete': '刪除',
  'pages.zy-crm.receipt-schedule.column.operation': '操作',
  'pages.zy-crm.receipt-schedule.modal.createTitle': '新增',
  'pages.zy-crm.receipt-schedule.modal.editTitle': '編輯',
  'pages.zy-crm.receipt-schedule.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.receipt-schedule.modal.deleteContent':
    '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.receipt-schedule.form.required': '必填項',
  'pages.zy-crm.receipt-schedule.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.receipt-schedule.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.receipt-schedule.form.placeholder.relation':
    '請輸入關聯{label}',
  'pages.zy-crm.receipt-schedule.form.bool.yes': '是',
  'pages.zy-crm.receipt-schedule.form.bool.no': '否',
  'pages.zy-crm.receipt-schedule.form.group.basic': '基礎資訊',
  'pages.zy-crm.receipt-schedule.form.group.followup': '跟進資訊',
  'pages.zy-crm.receipt-schedule.form.group.contact': '聯絡方式',
  'pages.zy-crm.receipt-schedule.form.group.business': '業務資訊',
  'pages.zy-crm.receipt-schedule.form.group.relation': '關聯資訊',
  'pages.zy-crm.receipt-schedule.form.group.detail': '備註或補充',
  'pages.zy-crm.receipt-schedule.form.group.other': '其他資訊',
  'pages.zy-crm.receipt-schedule.message.createSuccess': '建立成功',
  'pages.zy-crm.receipt-schedule.message.updateSuccess': '更新成功',
  'pages.zy-crm.receipt-schedule.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.receipt-schedule.message.noCreateApi': '後端未提供新增接口',
  'pages.zy-crm.receipt-schedule.message.noUpdateApi': '後端未提供更新接口',
  'pages.zy-crm.receipt-schedule.message.noDeleteApi': '後端未提供刪除接口',
  'pages.zy-crm.receipt-schedule.message.memberLoadFailed':
    '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.receipt-schedule.message.memberLoadBlocked':
    '成員列表載入失敗，暫時無法提交',
  'pages.zy-crm.receipt-schedule.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.receipt-schedule.member.unknown': '未知成員',
  'pages.zy-crm.receipt-schedule.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.receipt-schedule.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.receipt-schedule.state.relationDataEmpty':
    '關聯資料可按業務接口補充',
  'pages.zy-crm.receipt-schedule.card.relation': '關聯資料',
  'pages.zy-crm.receipt-schedule.search.expand': '展開',
  'pages.zy-crm.receipt-schedule.search.collapse': '收起',
  'pages.zy-crm.receipt-schedule.field.id': 'id',
  'pages.zy-crm.receipt-schedule.field.period': 'period',
  'pages.zy-crm.receipt-schedule.field.customerUuid': 'customer',
  'pages.zy-crm.receipt-schedule.field.contractUuid': 'contract',
  'pages.zy-crm.receipt-schedule.field.ownerUserUuid': '负责人',
  'pages.zy-crm.receipt-schedule.field.receiptUuid': 'receipt',
  'pages.zy-crm.receipt-schedule.field.receiptDate': 'receiptDate',
  'pages.zy-crm.receipt-schedule.field.receiptMethod': 'receiptMethod',
  'pages.zy-crm.receipt-schedule.field.price': 'price',
  'pages.zy-crm.receipt-schedule.field.receivedAmount': '已回款金額',
  'pages.zy-crm.receipt-schedule.field.unpaidAmount': '未回款金額',
  'pages.zy-crm.receipt-schedule.field.remindDays': 'remindDays',
  'pages.zy-crm.receipt-schedule.field.remindTime': 'remindTime',
  'pages.zy-crm.receipt-schedule.field.status': '執行狀態',
  'pages.zy-crm.receipt-schedule.field.systemStatus': '系統狀態',
  'pages.zy-crm.receipt-schedule.field.remark': 'remark',
  'pages.zy-crm.receipt.option.receiptMethod.bankTransfer': '銀行轉帳',
  'pages.zy-crm.receipt.option.receiptMethod.cash': '現金',
  'pages.zy-crm.receipt.option.receiptMethod.check': '支票',
  'pages.zy-crm.receipt.option.receiptMethod.other': '其他',
  'pages.zy-crm.receipt.option.status.draft': '草稿',
  'pages.zy-crm.receipt.option.status.pending': '審批中',
  'pages.zy-crm.receipt.option.status.approved': '已通過',
  'pages.zy-crm.receipt.option.status.rejected': '已拒絕',
  'pages.zy-crm.receipt-schedule.option.status.pending': '待執行',
  'pages.zy-crm.receipt-schedule.option.status.completed': '已完成',
  'pages.zy-crm.calendar.title': '日曆',
  'pages.zy-crm.calendar.action.today': '今天',
  'pages.zy-crm.calendar.action.prev': '上一個',
  'pages.zy-crm.calendar.action.next': '下一個',
  'pages.zy-crm.calendar.action.create': '建立',
  'pages.zy-crm.calendar.action.refresh': '重新整理',
  'pages.zy-crm.calendar.action.save': '儲存',
  'pages.zy-crm.calendar.action.delete': '刪除',
  'pages.zy-crm.calendar.action.openSource': '打開來源記錄',
  'pages.zy-crm.calendar.view.day': '日',
  'pages.zy-crm.calendar.view.week': '週',
  'pages.zy-crm.calendar.view.month': '月',
  'pages.zy-crm.calendar.view.list': '列表',
  'pages.zy-crm.calendar.sidebar.mySchedule': '我的日程',
  'pages.zy-crm.calendar.sidebar.systemType': '系統類型',
  'pages.zy-crm.calendar.sidebar.otherCalendar': '其他日曆',
  'pages.zy-crm.calendar.filter.my_schedule': '我的日程',
  'pages.zy-crm.calendar.filter.assigned_task': '分配的任務',
  'pages.zy-crm.calendar.filter.phone_communication': '電話溝通',
  'pages.zy-crm.calendar.filter.send_email': '發郵件',
  'pages.zy-crm.calendar.filter.online_meeting': '線上會議',
  'pages.zy-crm.calendar.filter.visit': '見面拜訪',
  'pages.zy-crm.calendar.filter.send_sms': '發短信',
  'pages.zy-crm.calendar.filter.lead_follow_up': '需聯繫的線索',
  'pages.zy-crm.calendar.filter.customer_follow_up': '需聯繫的客戶',
  'pages.zy-crm.calendar.filter.contact_follow_up': '需聯繫的聯絡人',
  'pages.zy-crm.calendar.filter.opportunity_follow_up': '需聯繫的商機',
  'pages.zy-crm.calendar.filter.opportunity_deal': '預計成交商機',
  'pages.zy-crm.calendar.filter.contract_expire': '即將到期的合同',
  'pages.zy-crm.calendar.filter.receipt_schedule': '計劃回款',
  'pages.zy-crm.calendar.drawer.createTitle': '新建日程',
  'pages.zy-crm.calendar.drawer.editTitle': '編輯日程',
  'pages.zy-crm.calendar.drawer.detailTitle': '日程詳情',
  'pages.zy-crm.calendar.form.title': '標題',
  'pages.zy-crm.calendar.form.eventType': '類型',
  'pages.zy-crm.calendar.form.startTime': '開始時間',
  'pages.zy-crm.calendar.form.endTime': '結束時間',
  'pages.zy-crm.calendar.form.allDay': '全天',
  'pages.zy-crm.calendar.form.location': '地點',
  'pages.zy-crm.calendar.form.description': '描述',
  'pages.zy-crm.calendar.form.color': '顏色',
  'pages.zy-crm.calendar.form.placeholder.title': '請輸入標題',
  'pages.zy-crm.calendar.form.placeholder.location': '請輸入地點',
  'pages.zy-crm.calendar.message.loadFailed': '日曆資料載入失敗',
  'pages.zy-crm.calendar.message.createSuccess': '日程已建立',
  'pages.zy-crm.calendar.message.updateSuccess': '日程已更新',
  'pages.zy-crm.calendar.message.deleteSuccess': '日程已刪除',
  'pages.zy-crm.calendar.message.saveFailed': '儲存失敗，請稍後重試',
  'pages.zy-crm.calendar.message.deleteFailed': '刪除失敗，請稍後重試',
  'pages.zy-crm.calendar.empty.noEventType': '請至少選擇一種日曆類型',
  'pages.zy-crm.calendar.readonly.system': '系統事件不支援編輯',
  'pages.zy-crm.quote.title': '報價單列表',
  'pages.zy-crm.quote.detailTitle': '報價單詳情',
  'pages.zy-crm.quote.action.refresh': '刷新',
  'pages.zy-crm.quote.action.create': '新建',
  'pages.zy-crm.quote.action.codeRule': '編號規則',
  'pages.zy-crm.quote.action.detail': '詳情',
  'pages.zy-crm.quote.action.edit': '編輯',
  'pages.zy-crm.quote.action.delete': '刪除',
  'pages.zy-crm.quote.action.restore': '恢復',
  'pages.zy-crm.quote.action.reuse': '復用',
  'pages.zy-crm.quote.action.history': '查看/復用歷史報價',
  'pages.zy-crm.quote.action.search': '搜索',
  'pages.zy-crm.quote.action.addProduct': '添加產品',
  'pages.zy-crm.quote.action.addRow': '添加行',
  'pages.zy-crm.quote.action.saveCodeRule': '保存規則',
  'pages.zy-crm.quote.column.operation': '操作',
  'pages.zy-crm.quote.modal.createTitle': '新建報價單',
  'pages.zy-crm.quote.modal.editTitle': '編輯報價單',
  'pages.zy-crm.quote.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.quote.modal.deleteContent': '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.quote.modal.restoreTitle': '是否恢復該報價單？',
  'pages.zy-crm.quote.modal.restoreContent': '可立即撤銷本次刪除操作。',
  'pages.zy-crm.quote.modal.historyTitle': '歷史報價',
  'pages.zy-crm.quote.modal.diffTitle': '報價金額差異確認',
  'pages.zy-crm.quote.modal.diffContent':
    '手工總額與明細計算值差異為 {diff}，確認繼續提交嗎？',
  'pages.zy-crm.quote.modal.crossCustomerTitle': '跨客戶復用確認',
  'pages.zy-crm.quote.modal.crossCustomerContent':
    '當前客戶與歷史報價客戶不一致，確認繼續將覆蓋客戶資訊嗎？',
  'pages.zy-crm.quote.modal.codeRuleTitle': '報價編號規則',
  'pages.zy-crm.quote.form.required': '必填項',
  'pages.zy-crm.quote.form.autoCodeHint': '根據編號規則自動生成',
  'pages.zy-crm.quote.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.quote.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.quote.form.group.basic': '基礎資訊',
  'pages.zy-crm.quote.form.group.relation': '關聯資訊',
  'pages.zy-crm.quote.form.group.date': '日期資訊',
  'pages.zy-crm.quote.form.group.product': '產品資訊',
  'pages.zy-crm.quote.form.group.amount': '金額彙總',
  'pages.zy-crm.quote.form.group.remark': '備註',
  'pages.zy-crm.quote.message.createSuccess': '建立成功',
  'pages.zy-crm.quote.message.updateSuccess': '更新成功',
  'pages.zy-crm.quote.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.quote.message.restoreSuccess': '恢復成功',
  'pages.zy-crm.quote.message.reuseSuccess': '歷史報價復用成功',
  'pages.zy-crm.quote.message.memberLoadFailed': '成員列表載入失敗，請稍後重試',
  'pages.zy-crm.quote.message.memberLoadBlocked':
    '成員列表載入失敗，暫時無法提交',
  'pages.zy-crm.quote.message.customerLoadFailed':
    '客戶列表載入失敗，請稍後重試',
  'pages.zy-crm.quote.message.contactLoadFailed':
    '聯絡人列表載入失敗，請稍後重試',
  'pages.zy-crm.quote.message.opportunityLoadFailed':
    '商機列表載入失敗，請稍後重試',
  'pages.zy-crm.quote.message.productLoadFailed':
    '產品列表載入失敗，請稍後重試',
  'pages.zy-crm.quote.message.historyLoadFailed': '歷史報價載入失敗',
  'pages.zy-crm.quote.message.productEmpty': '請至少添加一個產品明細',
  'pages.zy-crm.quote.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.quote.message.codeRuleLoadFailed': '報價編號規則載入失敗',
  'pages.zy-crm.quote.message.codeRuleUpdateSuccess': '編號規則更新成功',
  'pages.zy-crm.quote.search.expand': '展開',
  'pages.zy-crm.quote.search.collapse': '收起',
  'pages.zy-crm.quote.state.diffNeedsConfirm': '金額差異未確認，已取消提交',
  'pages.zy-crm.quote.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.quote.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.quote.history.range.lastMonth': '最近一個月',
  'pages.zy-crm.quote.history.range.halfYear': '近半年',
  'pages.zy-crm.quote.history.range.thisYear': '本年度',
  'pages.zy-crm.quote.table.emptyProducts': '暫無產品明細',
  'pages.zy-crm.quote.table.emptyHistory': '暫無歷史報價',
  'pages.zy-crm.quote.stats.selectedProducts': '已選中產品：{count} 種',
  'pages.zy-crm.quote.stats.quoteAmount': '總金額：{amount} 元',
  'pages.zy-crm.quote.option.dateFormat.none': '無日期',
  'pages.zy-crm.quote.option.dateFormat.yymm': '年/月(YYMM)',
  'pages.zy-crm.quote.option.dateFormat.yyyymmdd': '年/月/日(YYYYMMDD)',
  'pages.zy-crm.quote.option.resetCycle.none': '不重置',
  'pages.zy-crm.quote.option.resetCycle.year': '按年重置',
  'pages.zy-crm.quote.option.resetCycle.month': '按月重置',
  'pages.zy-crm.quote.status.approved': '已通過',
  'pages.zy-crm.quote.status.submitted': '審批中',
  'pages.zy-crm.quote.status.rejected': '已拒絕',
  'pages.zy-crm.quote.status.draft': '草稿',
  'pages.zy-crm.quote.field.code': '報價單編號',
  'pages.zy-crm.quote.field.name': '報價單名稱',
  'pages.zy-crm.quote.field.customerUuid': '客戶名稱',
  'pages.zy-crm.quote.field.contactUuid': '客戶聯絡人',
  'pages.zy-crm.quote.field.opportunityUuid': '商機名稱',
  'pages.zy-crm.quote.field.quoteDate': '報價日期',
  'pages.zy-crm.quote.field.expectedDealDate': '預計成交日期',
  'pages.zy-crm.quote.field.ownerUserUuid': '負責人',
  'pages.zy-crm.quote.field.ownerMobile': '負責人手機號',
  'pages.zy-crm.quote.field.auditStatus': '審核狀態',
  'pages.zy-crm.quote.field.discountPercent': '整單折扣(%)',
  'pages.zy-crm.quote.field.totalProductPrice': '產品成本總金額',
  'pages.zy-crm.quote.field.totalPrice': '報價金額',
  'pages.zy-crm.quote.field.profitAmount': '利潤',
  'pages.zy-crm.quote.field.remark': '備註',
  'pages.zy-crm.quote.field.sourceQuoteUuid': '來源報價單',
  'pages.zy-crm.quote.field.products': '產品',
  'pages.zy-crm.quote.field.productName': '產品名稱',
  'pages.zy-crm.quote.field.productType': '產品類型',
  'pages.zy-crm.quote.field.productUnit': '產品單位',
  'pages.zy-crm.quote.field.listPrice': '價格',
  'pages.zy-crm.quote.field.costPrice': '成本價',
  'pages.zy-crm.quote.field.salePrice': '售價',
  'pages.zy-crm.quote.field.quantity': '數量',
  'pages.zy-crm.quote.field.lineTotal': '小計',
  'pages.zy-crm.quote.field.historyRange': '時間範圍',
  'pages.zy-crm.quote.field.historyKeyword': '關鍵字',
  'pages.zy-crm.quote.field.dateFormat': '日期格式',
  'pages.zy-crm.quote.field.resetCycle': '重置週期',
  'pages.zy-crm.quote.field.seqLength': '序號位數',
  'pages.zy-crm.quote.field.prefix': '前綴',
  'pages.zy-crm.followUps.title': '跟進記錄列表',
  'pages.zy-crm.invoice.title': '發票列表',
  'pages.zy-crm.invoice.detailTitle': '發票詳情',
  'pages.zy-crm.invoice.action.refresh': '刷新',
  'pages.zy-crm.invoice.action.create': '新建發票',
  'pages.zy-crm.invoice.action.detail': '詳情',
  'pages.zy-crm.invoice.action.edit': '編輯',
  'pages.zy-crm.invoice.action.delete': '刪除',
  'pages.zy-crm.invoice.action.submit': '提交審核',
  'pages.zy-crm.invoice.action.addItem': '新增明細',
  'pages.zy-crm.invoice.action.back': '返回列表',
  'pages.zy-crm.invoice.action.save': '保存',
  'pages.zy-crm.invoice.action.cancel': '取消',
  'pages.zy-crm.invoice.action.manageProfile': '管理發票資訊',
  'pages.zy-crm.invoice.action.selectProfile': '選擇發票資訊',
  'pages.zy-crm.invoice.modal.createTitle': '新建發票',
  'pages.zy-crm.invoice.modal.editTitle': '編輯發票',
  'pages.zy-crm.invoice.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.invoice.modal.deleteContent': '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.invoice.column.operation': '操作',
  'pages.zy-crm.invoice.search.expand': '展開',
  'pages.zy-crm.invoice.search.collapse': '收起',
  'pages.zy-crm.invoice.form.group.basic': '基本資訊',
  'pages.zy-crm.invoice.form.group.invoice': '發票資訊',
  'pages.zy-crm.invoice.form.placeholder.input': '請輸入{label}',
  'pages.zy-crm.invoice.form.placeholder.select': '請選擇{label}',
  'pages.zy-crm.invoice.form.required': '必填項',
  'pages.zy-crm.invoice.message.createSuccess': '建立成功',
  'pages.zy-crm.invoice.message.updateSuccess': '更新成功',
  'pages.zy-crm.invoice.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.invoice.message.submitSuccess': '提交審核成功',
  'pages.zy-crm.invoice.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.invoice.message.profileRequired': '請選擇發票資訊',
  'pages.zy-crm.invoice.message.manualSnapshotRequired':
    '請輸入抬頭類型、開票抬頭和稅號',
  'pages.zy-crm.invoice.message.contractRequired': '請先選擇合約',
  'pages.zy-crm.invoice.message.itemsRequired': '請至少新增一條開票明細',
  'pages.zy-crm.invoice.member.unknown': '未知成員',
  'pages.zy-crm.invoice.state.missingUuid': '缺少 uuid 參數',
  'pages.zy-crm.invoice.state.detailNotFound': '未找到詳情資料',
  'pages.zy-crm.invoice.state.emptyItems': '暫無資料',
  'pages.zy-crm.invoice.state.relationDataEmpty': '關聯資料可按業務接口補充',
  'pages.zy-crm.invoice.placeholder.autoCode': '根據編號規則自動生成',
  'pages.zy-crm.invoice.field.code': '發票申請編號',
  'pages.zy-crm.invoice.field.customerUuid': '客戶名稱',
  'pages.zy-crm.invoice.field.customerName': '客戶名稱',
  'pages.zy-crm.invoice.field.contractUuid': '合約',
  'pages.zy-crm.invoice.field.contractName': '合約名稱',
  'pages.zy-crm.invoice.field.ownerUserUuid': '負責人',
  'pages.zy-crm.invoice.field.invoiceDate': '開票日期',
  'pages.zy-crm.invoice.field.invoiceType': '開票類型',
  'pages.zy-crm.invoice.field.auditStatus': '審核狀態',
  'pages.zy-crm.invoice.field.processInstanceUuid': '流程實例',
  'pages.zy-crm.invoice.field.invoiceProfileName': '抬頭名稱',
  'pages.zy-crm.invoice.field.totalAmount': '開票金額',
  'pages.zy-crm.invoice.field.remark': '備註',
  'pages.zy-crm.invoice.field.invoiceProfileUuid': '發票資訊',
  'pages.zy-crm.invoice.field.titleType': '抬頭類型',
  'pages.zy-crm.invoice.field.titleSnapshot': '開票抬頭',
  'pages.zy-crm.invoice.field.taxNoSnapshot': '納稅人識別號',
  'pages.zy-crm.invoice.field.bankNameSnapshot': '開戶行',
  'pages.zy-crm.invoice.field.bankAccountSnapshot': '開戶帳號',
  'pages.zy-crm.invoice.field.addressSnapshot': '開票地址',
  'pages.zy-crm.invoice.field.phoneSnapshot': '電話',
  'pages.zy-crm.invoice.field.saveAsProfile': '保存為常用發票資訊',
  'pages.zy-crm.invoice.field.mailContact': '聯絡人',
  'pages.zy-crm.invoice.field.mailPhone': '聯絡方式',
  'pages.zy-crm.invoice.field.mailAddressRegion': '郵寄地址',
  'pages.zy-crm.invoice.field.mailAddressDetail': '詳細地址',
  'pages.zy-crm.invoice.field.items': '開票明細',
  'pages.zy-crm.invoice.section.items': '回款明細',
  'pages.zy-crm.invoice.field.receiptCode': '回款編號',
  'pages.zy-crm.invoice.field.receiptScheduleCode': '回款計劃編號',
  'pages.zy-crm.invoice.field.contractCode': '合約編號',
  'pages.zy-crm.invoice.field.contractAmount': '合約金額',
  'pages.zy-crm.invoice.field.uninvoicedAmount': '未開票金額',
  'pages.zy-crm.invoice.field.invoiceAmount': '本次開票金額',
  'pages.zy-crm.invoice.field.receiptDate': '回款日期',
  'pages.zy-crm.invoice.field.receiptMethod': '回款方式',
  'pages.zy-crm.invoice.field.createdAt': '建立時間',
  'pages.zy-crm.invoice.option.type.normal': '普通發票',
  'pages.zy-crm.invoice.option.type.special': '專用發票',
  'pages.zy-crm.invoice.option.title.company': '單位',
  'pages.zy-crm.invoice.option.title.personal': '個人',
  'pages.zy-crm.invoice.option.status.draft': '草稿',
  'pages.zy-crm.invoice.option.status.pending': '待審核',
  'pages.zy-crm.invoice.option.status.approved': '已通過',
  'pages.zy-crm.invoice.option.status.rejected': '已駁回',
  'pages.zy-crm.invoice.section.mailing': '郵寄資訊',
  'pages.zy-crm.invoice.card.invoiceInfo': '發票資訊',
  'pages.zy-crm.invoice.card.mailing': '郵寄資訊',
  'pages.zy-crm.invoice-profile.title': '發票資訊管理',
  'pages.zy-crm.invoice-profile.action.refresh': '刷新',
  'pages.zy-crm.invoice-profile.action.create': '新建發票資訊',
  'pages.zy-crm.invoice-profile.action.edit': '編輯',
  'pages.zy-crm.invoice-profile.action.delete': '刪除',
  'pages.zy-crm.invoice-profile.column.operation': '操作',
  'pages.zy-crm.invoice-profile.modal.createTitle': '新建發票資訊',
  'pages.zy-crm.invoice-profile.modal.editTitle': '編輯發票資訊',
  'pages.zy-crm.invoice-profile.modal.deleteTitle': '確認刪除',
  'pages.zy-crm.invoice-profile.modal.deleteContent':
    '刪除後不可恢復，請謹慎操作。',
  'pages.zy-crm.invoice-profile.form.required': '必填項',
  'pages.zy-crm.invoice-profile.message.createSuccess': '建立成功',
  'pages.zy-crm.invoice-profile.message.updateSuccess': '更新成功',
  'pages.zy-crm.invoice-profile.message.deleteSuccess': '刪除成功',
  'pages.zy-crm.invoice-profile.message.detailLoadFailed': '詳情載入失敗',
  'pages.zy-crm.invoice-profile.field.name': '檔案名稱',
  'pages.zy-crm.invoice-profile.field.type': '抬頭類型',
  'pages.zy-crm.invoice-profile.field.title': '開票抬頭',
  'pages.zy-crm.invoice-profile.field.taxNo': '稅號',
  'pages.zy-crm.invoice-profile.field.bankName': '開戶行',
  'pages.zy-crm.invoice-profile.field.bankAccount': '開戶帳號',
  'pages.zy-crm.invoice-profile.field.address': '開票地址',
  'pages.zy-crm.invoice-profile.field.phone': '電話',
  'pages.zy-crm.invoice-profile.field.isDefault': '是否預設',
  'pages.zy-crm.invoice-profile.field.remark': '備註',
  'pages.zy-crm.invoice-profile.field.createdAt': '建立時間',
  'pages.zy-crm.invoice-profile.option.boolean.yes': '是',
  'pages.zy-crm.invoice-profile.option.boolean.no': '否',
  'pages.zy-crm.contactOpportunity.field.status': '狀態',
};
